import { InputStateController } from "./InputStateController.js";
/**
 * Creates a controller that manages the state of an input element.
 *
 * @beta This is a beta feature and may change in the future.
 */
// TODO Add documentation for this function.
export function controlInput(host, options) {
    return new InputStateController(host, options);
}
